import React from 'react';
import { Reveal } from '../hooks/useReveal';
import { IMAGES, TEAM } from '../data/mock';
import PageHero from '../components/PageHero';
import TrialCTA from '../components/TrialCTA';

export default function Equipe() {
  return (
    <>
      <PageHero
        eyebrow="Rencontre l'équipe"
        title="Les coachs"
        accent="Hybrid"
        img="athlete2"
        subtitle="Différents passés sportifs, une même passion : te faire progresser. Une équipe de coachs certifiés à ton service."
      />

      <section className="py-14 md:py-28 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={(i % 4) * 100}>
              <div className="hx-card group rounded-md overflow-hidden h-full">
                <div className="h-80 overflow-hidden relative">
                  <img src={IMAGES[m.img]} alt={m.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-3xl group-hover:text-accent transition-colors">{m.name}</h3>
                  <p className="font-cond text-xs tracking-widest text-accent mb-3">{m.role}</p>
                  <p className="text-[var(--hx-muted)] text-sm leading-relaxed">{m.bio}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <TrialCTA />
    </>
  );
}
